import { array, required, obj, optional } from 'AppReact/schema';

export const option = {
  id: required('integer'),
  index: required('integer'),
  comment_required: required('boolean'),
  is_completion: required('boolean'),
  is_na: required('boolean'),
  name: required('string')
}

export const inspectionItem = {
  id: required('integer'),
  name: required('string'),
  area: required('string'),
  options: array(obj(option)),
  input_type: optional('string')
}

export const commentActions = {
  require_attachment: required("boolean"),
  require_comment: required("boolean"),
  require_feedback: required("boolean"),
  require_attachment_all: required("boolean"),
  require_comment_all: required("boolean"),
  require_feedback_all: required("boolean"),
};

export default {
  id: required('integer'),
  name: required('string'),
  items: array(obj(inspectionItem)),
  icon: optional('string'),
  can_assign_resident: required('boolean'),
  can_assign_admin: required('boolean'),
  can_assign_tech: required('boolean'),
  active: required('boolean'),
  require_attachment: required('boolean'),
  require_comment: required('boolean'),
  require_feedback: required('boolean'),
  require_attachment_all: required("boolean"),
  require_comment_all: required("boolean"),
  require_feedback_all: required("boolean"),
  auto_create_work_orders: required('boolean'),
  resident_approval: required('boolean'),
}
